import React, { Component } from "react";
import { Link } from "react-router-dom";
import Masonry from "react-masonry-component";
import SimpleReactLightbox, {
	SRLWrapper,
	useLightbox,
} from "simple-react-lightbox";

// Layout
import Header from "../layout/header/header1";
import bannerImg from "../../images/robotics-for-good/banner.png";
import { withTranslation } from "react-i18next";

//Images
import Day1Img1 from "../../images/achievements/RoboticsInternationalFinal_Day1_1.jpg";
import Day1Img2 from "../../images/achievements/RoboticsInternationalFinal_Day1_2.jpg";
import Day1Img3 from "../../images/achievements/RoboticsInternationalFinal_Day1_3.jpg";
import Day1Img4 from "../../images/achievements/RoboticsInternationalFinal_Day1_4.jpg";
import Day1Img5 from "../../images/achievements/RoboticsInternationalFinal_Day1_5.jpg";
import Day1Img6 from "../../images/achievements/RoboticsInternationalFinal_Day1_6.jpg";
import Day1Img7 from "../../images/achievements/RoboticsInternationalFinal_Day1_7.jpg";
import Day1Img8 from "../../images/achievements/RoboticsInternationalFinal_Day1_8.jpg";
import Day1Img9 from "../../images/achievements/RoboticsInternationalFinal_Day1_9.jpg";
import Day1Img10 from "../../images/achievements/RoboticsInternationalFinal_Day1_10.jpg";
import Day1Img11 from "../../images/achievements/RoboticsInternationalFinal_Day1_11.jpg";
import Day1Img12 from "../../images/achievements/RoboticsInternationalFinal_Day1_12.jpg";
import Day1Img13 from "../../images/achievements/RoboticsInternationalFinal_Day1_13.jpg";
import Day1Img14 from "../../images/achievements/RoboticsInternationalFinal_Day1_14.jpg";
import Day1Img15 from "../../images/achievements/RoboticsInternationalFinal_Day1_15.jpg";
import Day1Img16 from "../../images/achievements/RoboticsInternationalFinal_Day1_16.jpg";

import Day2Img1 from "../../images/achievements/RoboticsInternationalFinal_Day2_1.jpg";
import Day2Img2 from "../../images/achievements/RoboticsInternationalFinal_Day2_2.jpg";
import Day2Img3 from "../../images/achievements/RoboticsInternationalFinal_Day2_3.jpg";
import Day2Img4 from "../../images/achievements/RoboticsInternationalFinal_Day2_4.jpg";
import Day2Img5 from "../../images/achievements/RoboticsInternationalFinal_Day2_5.jpg";
import Day2Img6 from "../../images/achievements/RoboticsInternationalFinal_Day2_6.jpg";
import Day2Img7 from "../../images/achievements/RoboticsInternationalFinal_Day2_7.jpg";
import Day2Img8 from "../../images/achievements/RoboticsInternationalFinal_Day2_8.jpg";
import Day2Img9 from "../../images/achievements/RoboticsInternationalFinal_Day2_9.jpg";
import Day2Img10 from "../../images/achievements/RoboticsInternationalFinal_Day2_10.jpg";

import Day3Img1 from "../../images/achievements/RoboticsInternationalFinal_Day3_1.jpg";
import Day3Img2 from "../../images/achievements/RoboticsInternationalFinal_Day3_2.jpg";
import Day3Img3 from "../../images/achievements/RoboticsInternationalFinal_Day3_3.jpg";
import Day3Img4 from "../../images/achievements/RoboticsInternationalFinal_Day3_4.jpg";
import Day3Img5 from "../../images/achievements/RoboticsInternationalFinal_Day3_5.jpg";
import Day3Img6 from "../../images/achievements/RoboticsInternationalFinal_Day3_6.jpg";

import Day4Img1 from "../../images/achievements/RoboticsInternationalFinal_Day4_1.jpg";
import Day4Img2 from "../../images/achievements/RoboticsInternationalFinal_Day4_2.jpg";
import Day4Img3 from "../../images/achievements/RoboticsInternationalFinal_Day4_3.jpg";
import Day4Img4 from "../../images/achievements/RoboticsInternationalFinal_Day4_4.jpg";
import Day4Img5 from "../../images/achievements/RoboticsInternationalFinal_Day4_5.jpg";
import Day4Img6 from "../../images/achievements/RoboticsInternationalFinal_Day4_6.jpg";
import Day4Img7 from "../../images/achievements/RoboticsInternationalFinal_Day4_7.jpg";
import Day4Img8 from "../../images/achievements/RoboticsInternationalFinal_Day4_8.jpg";
import Day4Img9 from "../../images/achievements/RoboticsInternationalFinal_Day4_9.jpg";


const MagnificAnchor = (props) => {
  const { openLightbox } = useLightbox();

  return (
    <Link
      to={"#"}
      onClick={() => openLightbox(props.imageToOpen)}
      className="magnific-anchor"
    >
      <i className="ti-search"></i>
    </Link>
  );
};

const options = {
  settings: {
    overlayColor: "rgba(0,0,0,0.9)",
    backgroundColor: "#f7b205",
    slideAnimationType: "slide",
  },
  buttons: {
    backgroundColor: "#f7b205",
    iconColor: "rgba(255, 255, 255, 1)",
    showAutoplayButton: false,
    showDownloadButton: false,
  },
  caption: {
    captionColor: "#a6cfa5",
    captionFontFamily: "Raleway, sans-serif",
    captionFontWeight: "300",
    captionTextTransform: "uppercase",
  },
};

const content = [
  // Day 1 images
  {
    thumb: Day1Img1,
    LightImg: Day1Img1,
    tag: "Day1",
    title: "Team Australia Shines",
  },
  {
    thumb: Day1Img2,
    LightImg: Day1Img2,
    tag: "Day1",
    title: "Team Australia Shines",
  },
  {
    thumb: Day1Img3,
    LightImg: Day1Img3,
    tag: "Day1",
    title: "Team Australia Shines",
  },
  {
    thumb: Day1Img4,
    LightImg: Day1Img4,
    tag: "Day1",
    title: "Team Australia Shines",
  },
  {
    thumb: Day1Img5,
    LightImg: Day1Img5,
    tag: "Day1",
    title: "Team Australia Shines",
  },
  {
    thumb: Day1Img6,
    LightImg: Day1Img6,
    tag: "Day1",
    title: "Team Australia Shines",
  },
  {
    thumb: Day1Img7,
    LightImg: Day1Img7,
    tag: "Day1",
    title: "Team Australia Shines",
  },
  {
    thumb: Day1Img8,
    LightImg: Day1Img8,
    tag: "Day1",
    title: "Team Australia Shines",
  },
  {
    thumb: Day1Img9,
    LightImg: Day1Img9,
    tag: "Day1",
    title: "Team Australia Shines",
  },
  {
    thumb: Day1Img10,
    LightImg: Day1Img10,
    tag: "Day1",
    title: "Team Australia Shines",
  },
  {
    thumb: Day1Img11,
    LightImg: Day1Img11,
    tag: "Day1",
    title: "Team Australia Shines",
  },
  {
    thumb: Day1Img12,
    LightImg: Day1Img12,
    tag: "Day1",
    title: "Team Australia Shines",
  },
  {
    thumb: Day1Img13,
    LightImg: Day1Img13,
    tag: "Day1",
    title: "Team Australia Shines",
  },
  {
    thumb: Day1Img14,
    LightImg: Day1Img14,
    tag: "Day1",
    title: "Team Australia Shines",
  },
  {
    thumb: Day1Img15,
    LightImg: Day1Img15,
    tag: "Day1",
    title: "Team Australia Shines",
  },
  {
    thumb: Day1Img16,
    LightImg: Day1Img16,
    tag: "Day1",
    title: "Team Australia Shines",
  },

  // Day 2 images

  {
    thumb: Day2Img1,
    LightImg: Day2Img1,
    tag: "Day2",
    title: "Robotics for Good Global Grand Finale",
  },
  {
    thumb: Day2Img2,
    LightImg: Day2Img2,
    tag: "Day2",
    title: "Robotics for Good Global Grand Finale",
  },
  {
    thumb: Day2Img3,
    LightImg: Day2Img3,
    tag: "Day2",
    title: "Robotics for Good Global Grand Finale",
  },
  {
    thumb: Day2Img4,
    LightImg: Day2Img4,
    tag: "Day2",
    title: "Robotics for Good Global Grand Finale",
  },
  {
    thumb: Day2Img5,
    LightImg: Day2Img5,
    tag: "Day2",
    title: "Robotics for Good Global Grand Finale",
  },
  {
    thumb: Day2Img6,
    LightImg: Day2Img6,
    tag: "Day2",
    title: "Robotics for Good Global Grand Finale",
  },
  {
    thumb: Day2Img7,
    LightImg: Day2Img7,
    tag: "Day2",
    title: "Robotics for Good Global Grand Finale",
  },
  {
    thumb: Day2Img8,
    LightImg: Day2Img8,
    tag: "Day2",
    title: "Robotics for Good Global Grand Finale",
  },
  {
    thumb: Day2Img9,
    LightImg: Day2Img9,
    tag: "Day2",
    title: "Robotics for Good Global Grand Finale",
  },
  {
    thumb: Day2Img10,
    LightImg: Day2Img10,
    tag: "Day2",
    title: "Robotics for Good Global Grand Finale",
  },

  // Day 3 images

  {
    thumb: Day3Img1,
    LightImg: Day3Img1,
    tag: "Day3",
    title: "Resilience and Breakthroughs",
  },
  {
    thumb: Day3Img2,
    LightImg: Day3Img2,
    tag: "Day3",
    title: "Resilience and Breakthroughs",
  },
  {
    thumb: Day3Img3,
    LightImg: Day3Img3,
    tag: "Day3",
    title: "Resilience and Breakthroughs",
  },
  {
    thumb: Day3Img4,
    LightImg: Day3Img4,
    tag: "Day3",
    title: "Resilience and Breakthroughs",
  },
  {
    thumb: Day3Img5,
    LightImg: Day3Img5,
    tag: "Day3",
    title: "Resilience and Breakthroughs",
  },
  {
    thumb: Day3Img6,
    LightImg: Day3Img6,
    tag: "Day3",
    title: "Resilience and Breakthroughs",
  },

  // Day 4 images

  {
    thumb: Day4Img1,
    LightImg: Day4Img1,
    tag: "Day4",
    title: "Preparation, Pressure and Continued Growth",
  },
  {
    thumb: Day4Img2,
    LightImg: Day4Img2,
    tag: "Day4",
    title: "Preparation, Pressure and Continued Growth",
  },
  {
    thumb: Day4Img3,
    LightImg: Day4Img3,
    tag: "Day4",
    title: "Preparation, Pressure and Continued Growth",
  },
  {
    thumb: Day4Img4,
    LightImg: Day4Img4,
    tag: "Day4",
    title: "Preparation, Pressure and Continued Growth",
  },
  {
    thumb: Day4Img5,
    LightImg: Day4Img5,
    tag: "Day4",
    title: "Preparation, Pressure and Continued Growth",
  },
  {
    thumb: Day4Img6,
    LightImg: Day4Img6,
    tag: "Day4",
    title: "Preparation, Pressure and Continued Growth",
  },
  {
    thumb: Day4Img7,
    LightImg: Day4Img7,
    tag: "Day4",
    title: "Preparation, Pressure and Continued Growth",
  },
  {
    thumb: Day4Img8,
    LightImg: Day4Img8,
    tag: "Day4",
    title: "Preparation, Pressure and Continued Growth",
  },
  {
    thumb: Day4Img9,
    LightImg: Day4Img9,
    tag: "Day4",
    title: "Preparation, Pressure and Continued Growth",
  },
];

const roboticsFinaleDays = [
  "Day1",
  "Day2",
  "Day3",
  "Day4",
]

function MasonaryContent() {

  return (
    <>
      <div>
        {roboticsFinaleDays.map((day, index) => {
          const imagesForDay = content.filter(
            (image) => image.tag === day
          )

          if (imagesForDay.length === 0) {
            return null;
          }
          return (
            <div key={index} className="m-t40">
              {
                day === "Day1" &&
                <>
                  <h5>🇦🇺 Team Australia Shines on Day 1 in Geneva! 🤖🌍</h5>

                  <p>What an inspiring first day for Team Australia at the Robotics for Good Youth Challenge Grand Finale 2026, part of the 
                    <a href="https://www.linkedin.com/company/ai-for-good-global-summit-un/"><strong> AI for Good </strong></a>
                     Global Summit in Geneva.</p>

                  <p>Our eye-catching booths, distinctive team uniforms, innovative robots and, most importantly, the students’ confident, positive and professional presence attracted significant attention throughout the day.</p>

                  <p>Teams from many countries, media representatives, government delegates and distinguished guests visited our booths to meet the students and learn about their work.</p>

                  <p>Our students proudly demonstrated their robots, explained the technology behind their designs and shared how their solutions aim to address real challenges in agriculture and food security.</p>

                  <p>Many visitors praised not only their technical knowledge and communication skills, but also their strong understanding of Technology for Good—using AI and robotics responsibly to solve meaningful problems and create a more sustainable future.</p>

                  <p>We are incredibly proud of the professionalism, enthusiasm and warmth shown by every member of Team Australia.</p>

                  <p>A wonderful beginning to an unforgettable global journey!</p>

                </>
              }

              {
                day === "Day2" &&
                <>
                  <h5>Day 2 at the Robotics for Good Global Grand Finale</h5>

                  <p>Our students continued to perform under pressure, adapting their robots to a competition environment that was very different from their training conditions.</p>

                  <p>With unfamiliar lighting, field conditions and unexpected technical challenges, they worked together to identify problems, adjust their solutions and keep moving forward as a team.</p>

                  <p>The day was also about learning beyond the competition. Students connected with teams from other countries, exchanged ideas, and gained new perspectives through international collaboration.</p>

                  <p>Two of our students were also interviewed by
                    <a href="https://www.linkedin.com/showcase/unicef-technology/"><strong> UNICEF Digital Impact, </strong></a>
                    sharing their thoughts on responsible AI, human-centred innovation and the role young people can play in shaping the future of technology.</p>

                  <p>In the evening, the organisers brought the students together for dinner after another demanding day. Even before and after the meal, the coaches continued discussing programming logic with the students—proof that learning does not always stop when the competition ends. 😄</p>

                  <p>These experiences build far more than technical skills. They develop resilience, adaptability, teamwork and the confidence to solve real-world problems together.</p>

                </>
              }

              {
                day === "Day3" &&
                <>
                  <h5>🇦🇺 Day 3: Resilience and Breakthroughs for Team Australia 🤖</h5>

                  <p>As the Robotics for Good Youth Challenge Grand Finale entered its most intense stage, severe wireless interference at the venue forced both Australian teams to make major changes to their robots.</p>

                  <p>The Junior Team, guided by their coaches, rewrote programs and redesigned parts of their robot. The Senior Team independently investigated the problem and worked late into the night to deploy new code.</p>

                  <p>After only a few hours of sleep, the Junior Team students and coaches, together with the Senior Team students, returned to the venue at 6:00 am to continue testing.</p>

                  <p>Their hard work paid off. The Senior Team again achieved a perfect score on Task 1, while the Junior Team recalibrated their sensors and achieved multiple perfect scores in training.</p>

                  <p>After the competition, the Senior Team developed four possible solutions for Task 2, while the Junior Team continued refining their redesigned robot.</p>

                  <p>This is real engineering: adapting under pressure, solving problems and never giving up.</p>

                </>
              }

              {
                day === "Day4" &&
                <>
                  <h5>Day 4 — Preparation, Pressure and Continued Growth</h5>

                  <p>The final day of the Robotics for Good Youth Challenge brought unexpected setbacks, but both Australian teams continued adapting under pressure.</p>

                  <p>The Senior Team had worked late into Day 3 to develop three solutions to overcome wireless-control challenges, including UDP and Low Frame approaches suggested by Professor
                    <a href="https://www.linkedin.com/in/simon-lucey-143425114/"><strong> Simon Lucey</strong></a>
                    , director of AIML. All three worked during testing. However, just before Round 4, a broken wheel forced a switch to the final backup robot. Its different camera meant two solutions could no longer be used, leaving only one option after a rapid YOLOv8 recalibration. Despite the setbacks and manual adjustment penalties, the team successfully demonstrated their dual AI-robot system.
                  </p>

                  <p>The Junior Team had repeatedly achieved full scores the previous evening and again that morning. Some students were only 10 years old, yet they modified code, debugged the robot and solved problems themselves on site, with guidance from their coaches.</p>

                  <p>At the start of Round 4, one seed block was underneath the robot and not visible during setup, so it was not placed on the robot. It later became caught beneath a wheel, preventing the robot from moving straight during Task 1. Immediately afterwards, the same robot and program were tested again—and achieved a full score.</p>

                  <p>These challenges highlighted the importance of contingency planning. Backup robots, spare batteries from Australia and Germany, and flexible hardware allowed both teams to continue when equipment failed or competition conditions changed.</p>

                  <p>This preparation was made possible through the support of the 
                    <a href="https://www.linkedin.com/company/south-australian-department-of-treasury-and-finance/"><strong> South Australian Department of Treasury and Finance (DTF)</strong></a>
                    's Office for Artificial Intelligence and Inspiring Australia - an Australian Government initiative. We are sincerely grateful for their support at critical moments.
                  </p>

                  <p>Despite the setbacks, both Australian teams were recognised as Finalist Teams at the Geneva Grand Finale.</p>

                  <p>Most importantly, neither team gave up. Across the four days, the students continued learning, adapting and taking ownership of their solutions. Their resilience, independent thinking, teamwork and determination—supported by careful preparation behind the scenes—were achievements worth far more than any final score.</p>

                </>
              }

              <SimpleReactLightbox>
                <SRLWrapper options={options}>
                  <Masonry className="ttr-gallery-listing">
                    {imagesForDay.map((item, index) => (
                      <div
                        className="action-card col-lg-3 col-md-4 col-sm-6"
                        key={index}
                      >
                        <div className="ttr-box achievements-bx">
                          <div className="ttr-media media-ov2 media-effect m-tb10">
                            <img alt="" src={item.thumb} />
                            <div className="ov-box">
                              <div className="overlay-icon align-m">
                                <MagnificAnchor imageToOpen={index} />
                              </div>
                              <div className="achievements-info-bx">
                                <h4>{item.title}</h4>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </Masonry>
                </SRLWrapper>
              </SimpleReactLightbox>
            </div>
          );
        })}
      </div>
    </>
  );
}


class RoboticsForGoodJourney extends Component {
  constructor(props) {
    super(props);
    this.wrapperRef = React.createRef();
    this.state = {};
  }

  componentDidMount() {}

  render() {
    const { t } = this.props;

    return (
      <>
        <Header />
        <div className="page-content">
          <div className="content-block" id="content-area">
            {/* 🖼️ 页面顶部横幅 */}
            <div
              className="page-banner"
              style={{ backgroundImage: `url(${bannerImg})` }}
            >
              <div className="container">
                <div className="page-banner-entry">
                  <h1 className="text-white">{t("Robotics_For_Good_Journey_Title")}</h1>
                </div>
              </div>
            </div>

            {/* 🧭 面包屑导航 */}
            <div className="breadcrumb-row">
              <div className="container">
                <ul className="list-inline">
                  <li>
                    <Link to="/">{t("Robotics_For_Good_Journey_LinkHome")}</Link>
                  </li>
                  <li>{t("Robotics_For_Good_Journey_Link")}</li>
                </ul>
              </div>
            </div>

            {/* 📅 Event Timeline Section */}
            <div className="section-full content-inner bg-white m-t30">
              <div className="container">
                <div className="section-head style-1 text-center">
                  <h2 className="title">Event Timeline</h2>
                </div>

                <div className="row">
                  <div className="col-lg-12">
                    <h4>📍 State Team Selection – by the end of November 2025</h4>
                    <p>
                      All states finalize their Junior and Senior teams for the national competition.
                    </p>

                    <h4>🏟 Australian National Competition – 28th March, 2026</h4>
                    <p>
                      Venue: Glenunga International High School, Adelaide. All state-selected teams compete at the national level. <a href="/news-11" style={{ textDecoration: 'underline' }}>More Details</a>
                    </p>

                    <h4>🌍 Grand Finale – July 2026</h4>
                    <p>
                      Location: Geneva, Switzerland. The winning Junior and Senior teams from Australia represent the country at the Robotics for Good Youth Challenge Global Summit 2026. Travel and accommodation are self-funded.
                    </p>

                    <MasonaryContent />

                    <hr className="m-t30 m-b30" />

                    <h4>📢 Updates</h4>
                    <p>
                      Details of each stage — including training sessions, competition highlights, team results, and media coverage — will be published here after each milestone is completed. Stay tuned for updates as the journey unfolds.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            {/* END Section */}
          </div>
        </div>
      </>
    );
  }
}

export default RoboticsForGoodJourney = withTranslation()(RoboticsForGoodJourney);
